import { createThunkRequest, POST } from '@webapp/account/src/libs/request';

import { history } from '@webapp/common/lib/history';

import { getProfile } from '../profile/async';
import { AccountRoutes } from '../routes';

import { mapLicense } from './license';
import { mapHistoryOrder, reverseMapOrderData } from './map';
import type { OrderData } from './order-data';
import type { Order } from './state';

export const getLicense = createThunkRequest(
    'orders/getLicense',
    async () => {
        const { rows } = await POST('show/possible_licenses');
        return {
            licenses: rows.map(mapLicense),
        };
    },
    { notify: false },
);

export const getHistoryList = createThunkRequest(
    'orders/getHistoryList',
    async () => {
        const { rows } = await POST('show/object', {
            object: 'invoice',
        });
        return {
            histories: rows.map(mapHistoryOrder),
        };
    },
    { notify: false },
);

export const getInvoice = createThunkRequest(
    'orders/getInvoice',
    async (orderId: number) => {
        const resp = await POST('get/invoice', {
            invoice: orderId,
        });
        window.open(resp.file);
        return resp;
    },
    { notify: false },
);

export const getAct = createThunkRequest(
    'orders/getAct',
    async (orderId: number) => {
        const resp = await POST('get/act', {
            invoice: orderId,
        });
        window.open(resp.file);
        return resp;
    },
    { notify: false },
);

export const removeOrder = createThunkRequest(
    'orders/removeOrder',

    async ({ orderId }: { orderId: number }) => {
        const { message } = await POST('delete/object', {
            object: 'invoice',
            id: orderId,
        });

        return {
            orderId,
            message,
        };
    },
);

export const sendOrder = createThunkRequest(
    'orders/sendOrder',
    async (
        {
            orderData,
            orders,
        }: {
            orderData: OrderData;
            orders: Array<{
                id: number;
                amount: number;
            }>;
        },
        { dispatch },
    ) => {
        const items = orders.map(({ amount, id }: Order) => ({
            license: id,
            qnt: amount,
        }));
        const data = reverseMapOrderData(orderData);

        const { id } = await POST('buy/license', {
            items: JSON.stringify(items),
            data: JSON.stringify(data),
        });

        dispatch(getProfile({ auth: true }));
        history.push(AccountRoutes.ordersLicencePay.create(id));

        return {
            id,
            message: 'Заказ успешно добавлен',
        };
    },
);
